var map = {
	"./HK.jpg": "1ecd",
	"./HK1.jpg": "86fb",
	"./Hogwarts.jpg": "e821",
	"./Osaka.jpg": "fcba",
	"./Pusan1.jpg": "7b06",
	"./Pusan2.jpg": "573e",
	"./S__8126511.jpg": "6456",
	"./Sydney.jpg": "e0ce",
	"./Sydney1.jpg": "b90f",
	"./Tainan_art.jpg": "cf5e",
	"./Taiwan.jpg": "b42b",
	"./Tokyo.jpg": "0c51",
	"./UK.jpg": "d856",
	"./UK2.jpg": "5adb",
	"./badminton.jpg": "fa4f",
	"./box.jpg": "0295",
	"./volleyball.jpg": "c99f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3ccf";